import React from "react";
import { Route, Routes } from "react-router-dom";
import { PosSettingsDetails } from "..";

export const POSSettings = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<PosSettingsDetails />} />
      </Routes>
    </>
  );
};
